import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'


const PageConst= {
  ACTION: {
    M00201_getTimeLimit: {
      api: 'M0040TimeLimitService.M00201_getTimeLimit',
      input: {}
    },
    M00201_getClassroomsDropdown: {
      api: 'M0120ClassroomService.M00201_getClassroomsDropdown',
      input: {}
    },
  },
}

const module = {
  state: {
    PageConst,
    init: false,
    timeLimit: [],
    searchInfo: {
      start_date: null,
      end_date: null,
      center_no: null,
      belongs_classroom_no: null,
    },
    intermediateScheduleData: {},
    M00201_scheduleData: [],
    M00201_calendarData: [],
    M00201_classroomDropDown: [],
    t0063_regular_schedule_control: [],
  },
  getters: {},
  mutations: {
    async initData (state) {
      const timeLimitList = state.timeLimit.filter(item => item.time_division === 0)

      const cellMap = {}
      const baseCell = {
        _isClosed: false,
        label: 0,
      }
      const offDayCell = {
        _isClosed: true,
        label: '',
      }

      // Initialize empty structure
      state.M00201_calendarData.forEach((calendar) => { // Calendar
        timeLimitList.forEach((timeLimit) => { // Time Limit
          for (let timeDivision = 0; timeDivision <= 2; timeDivision++) { // Time Division
            for (let capacity = 1; capacity <= 2; capacity++) { // Capacity
              let isClosed = false
              if (
                timeLimit.time_limit_no < calendar.start_time_limit_no ||
                timeLimit.time_limit_no > calendar.end_time_limit_no
              ) {
                isClosed = true
              }
              cellMap[calendar.schedule_date + '_' + timeLimit.time_limit_group_no + timeDivision + '_' + capacity] = isClosed ? offDayCell : baseCell
            }
          }
        })
      })

      // Insert Data
      state.M00201_scheduleData.forEach((schedule) => {
        cellMap[schedule.data_key] = {
          ...cellMap[schedule.data_key],
          label: schedule.cnt
        }
      })

      state.intermediateScheduleData = cellMap
    }
  },
  actions: {
    async M00201_init ({ state }, payload) {
      const res = await $this.$api.postData({
        data: {
          M00201_getTimeLimit: PageConst.ACTION.M00201_getTimeLimit,
          M00201_getClassroomsDropdown: PageConst.ACTION.M00201_getClassroomsDropdown
        }
      })
      state.timeLimit = res.M00201_getTimeLimit.output
      state.M00201_classroomDropDown = res.M00201_getClassroomsDropdown.output
    },
    async M00201_doBrowse ({ state }, payload) {
      const res = await $this.$api.postData({
        data: {
          M00201_doBrowse: {
            api: 'T1030EntryScheduleWeekService.M00201_doBrowse',
            input: state.searchInfo
          },
          M00201_getCalendarByRangeWithSeminar: {
            api: 'T0050CalendarService.getCalendarByRangeWithSeminar',
            input: {
              start_date: state.searchInfo.start_date,
              end_date: state.searchInfo.end_date,
            }
          },
          t0063_regular_schedule_control: {
            api: 'T0063RegularScheduleControlService.getRegularScheduleControlDate',
            input: {
              start_date: state.searchInfo.start_date,
              end_date: state.searchInfo.end_date,
            }
          },
        }
      })
      state.M00201_scheduleData = res.M00201_doBrowse.output
      state.M00201_calendarData = res.M00201_getCalendarByRangeWithSeminar.output
      state.t0063_regular_schedule_control = res.t0063_regular_schedule_control.output

      await this.commit('M00201/initData')
      state.init = true
    },
    async M00201_exportCSV ({ state }) {
      const res = await $this.$api.postData({
        data: [{
          api: 'T1030EntryScheduleWeekService.M00201_exportCSV',
          input: state.searchInfo
        }]
      })
      return res[0].output;
    },
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
